import { LOCALES, type Locale } from '@ambernord/shared';

// --- common (čaula/navigācija) ---
import deCommon from './locales/de/common.json' with { type: 'json' };
import enCommon from './locales/en/common.json' with { type: 'json' };
import ltCommon from './locales/lt/common.json' with { type: 'json' };
import lvCommon from './locales/lv/common.json' with { type: 'json' };

import deAdmin from './locales/de/admin.json' with { type: 'json' };
import deArchive from './locales/de/archive.json' with { type: 'json' };
import deAuth from './locales/de/auth.json' with { type: 'json' };
import deChat from './locales/de/chat.json' with { type: 'json' };
import deClaims from './locales/de/claims.json' with { type: 'json' };
import deCompliance from './locales/de/compliance.json' with { type: 'json' };
import deDashboard from './locales/de/dashboard.json' with { type: 'json' };
import deDocuments from './locales/de/documents.json' with { type: 'json' };
import deInsurance from './locales/de/insurance.json' with { type: 'json' };
import deNeworder from './locales/de/neworder.json' with { type: 'json' };
import deOffers from './locales/de/offers.json' with { type: 'json' };
import deOrders from './locales/de/orders.json' with { type: 'json' };
import dePricing from './locales/de/pricing.json' with { type: 'json' };
import deProducts from './locales/de/products.json' with { type: 'json' };
import deRegistry from './locales/de/registry.json' with { type: 'json' };
import deSecurity from './locales/de/security.json' with { type: 'json' };
import deSodetail from './locales/de/sodetail.json' with { type: 'json' };
import deStatuses from './locales/de/statuses.json' with { type: 'json' };
import deSupplyOrders from './locales/de/supplyorders.json' with { type: 'json' };
import deTasks from './locales/de/tasks.json' with { type: 'json' };
import deTraceability from './locales/de/traceability.json' with { type: 'json' };
// --- lapu namespaces (katra lapa = atsevišķs fails) ---
import enAdmin from './locales/en/admin.json' with { type: 'json' };
import enArchive from './locales/en/archive.json' with { type: 'json' };
import enAuth from './locales/en/auth.json' with { type: 'json' };
import enChat from './locales/en/chat.json' with { type: 'json' };
import enClaims from './locales/en/claims.json' with { type: 'json' };
import enCompliance from './locales/en/compliance.json' with { type: 'json' };
import enDashboard from './locales/en/dashboard.json' with { type: 'json' };
import enDocuments from './locales/en/documents.json' with { type: 'json' };
import enInsurance from './locales/en/insurance.json' with { type: 'json' };
import enNeworder from './locales/en/neworder.json' with { type: 'json' };
import enOffers from './locales/en/offers.json' with { type: 'json' };
import enOrders from './locales/en/orders.json' with { type: 'json' };
import enPricing from './locales/en/pricing.json' with { type: 'json' };
import enProducts from './locales/en/products.json' with { type: 'json' };
import enRegistry from './locales/en/registry.json' with { type: 'json' };
import enSecurity from './locales/en/security.json' with { type: 'json' };
import enSodetail from './locales/en/sodetail.json' with { type: 'json' };
import enStatuses from './locales/en/statuses.json' with { type: 'json' };
import enSupplyOrders from './locales/en/supplyorders.json' with { type: 'json' };
import enTasks from './locales/en/tasks.json' with { type: 'json' };
import enTraceability from './locales/en/traceability.json' with { type: 'json' };
import ltAdmin from './locales/lt/admin.json' with { type: 'json' };
import ltArchive from './locales/lt/archive.json' with { type: 'json' };
import ltAuth from './locales/lt/auth.json' with { type: 'json' };
import ltChat from './locales/lt/chat.json' with { type: 'json' };
import ltClaims from './locales/lt/claims.json' with { type: 'json' };
import ltCompliance from './locales/lt/compliance.json' with { type: 'json' };
import ltDashboard from './locales/lt/dashboard.json' with { type: 'json' };
import ltDocuments from './locales/lt/documents.json' with { type: 'json' };
import ltInsurance from './locales/lt/insurance.json' with { type: 'json' };
import ltNeworder from './locales/lt/neworder.json' with { type: 'json' };
import ltOffers from './locales/lt/offers.json' with { type: 'json' };
import ltOrders from './locales/lt/orders.json' with { type: 'json' };
import ltPricing from './locales/lt/pricing.json' with { type: 'json' };
import ltProducts from './locales/lt/products.json' with { type: 'json' };
import ltRegistry from './locales/lt/registry.json' with { type: 'json' };
import ltSecurity from './locales/lt/security.json' with { type: 'json' };
import ltSodetail from './locales/lt/sodetail.json' with { type: 'json' };
import ltStatuses from './locales/lt/statuses.json' with { type: 'json' };
import ltSupplyOrders from './locales/lt/supplyorders.json' with { type: 'json' };
import ltTasks from './locales/lt/tasks.json' with { type: 'json' };
import ltTraceability from './locales/lt/traceability.json' with { type: 'json' };
import lvAdmin from './locales/lv/admin.json' with { type: 'json' };
import lvArchive from './locales/lv/archive.json' with { type: 'json' };
import lvAuth from './locales/lv/auth.json' with { type: 'json' };
import lvChat from './locales/lv/chat.json' with { type: 'json' };
import lvClaims from './locales/lv/claims.json' with { type: 'json' };
import lvCompliance from './locales/lv/compliance.json' with { type: 'json' };
import lvDashboard from './locales/lv/dashboard.json' with { type: 'json' };
import lvDocuments from './locales/lv/documents.json' with { type: 'json' };
import lvInsurance from './locales/lv/insurance.json' with { type: 'json' };
import lvNeworder from './locales/lv/neworder.json' with { type: 'json' };
import lvOffers from './locales/lv/offers.json' with { type: 'json' };
import lvOrders from './locales/lv/orders.json' with { type: 'json' };
import lvPricing from './locales/lv/pricing.json' with { type: 'json' };
import lvProducts from './locales/lv/products.json' with { type: 'json' };
import lvRegistry from './locales/lv/registry.json' with { type: 'json' };
import lvSecurity from './locales/lv/security.json' with { type: 'json' };
import lvSodetail from './locales/lv/sodetail.json' with { type: 'json' };
import lvStatuses from './locales/lv/statuses.json' with { type: 'json' };
import lvSupplyOrders from './locales/lv/supplyorders.json' with { type: 'json' };
import lvTasks from './locales/lv/tasks.json' with { type: 'json' };
import lvTraceability from './locales/lv/traceability.json' with { type: 'json' };

export const defaultNS = 'common' as const;
export const namespaces = [
  'common',
  'dashboard',
  'products',
  'orders',
  'supplyorders',
  'neworder',
  'admin',
  'pricing',
  'documents',
  'traceability',
  'claims',
  'tasks',
  'registry',
  'compliance',
  'insurance',
  'archive',
  'chat',
  'auth',
  'statuses',
  'offers',
  'sodetail',
  'security',
] as const;

export const resources = {
  en: {
    common: enCommon,
    dashboard: enDashboard,
    products: enProducts,
    orders: enOrders,
    supplyorders: enSupplyOrders,
    neworder: enNeworder,
    admin: enAdmin,
    pricing: enPricing,
    documents: enDocuments,
    traceability: enTraceability,
    claims: enClaims,
    tasks: enTasks,
    registry: enRegistry,
    security: enSecurity,
    compliance: enCompliance,
    insurance: enInsurance,
    archive: enArchive,
    chat: enChat,
    auth: enAuth,
    statuses: enStatuses,
    offers: enOffers,
    sodetail: enSodetail,
  },
  de: {
    common: deCommon,
    dashboard: deDashboard,
    products: deProducts,
    orders: deOrders,
    supplyorders: deSupplyOrders,
    neworder: deNeworder,
    admin: deAdmin,
    pricing: dePricing,
    documents: deDocuments,
    traceability: deTraceability,
    claims: deClaims,
    tasks: deTasks,
    registry: deRegistry,
    security: deSecurity,
    compliance: deCompliance,
    insurance: deInsurance,
    archive: deArchive,
    chat: deChat,
    auth: deAuth,
    statuses: deStatuses,
    offers: deOffers,
    sodetail: deSodetail,
  },
  lv: {
    common: lvCommon,
    dashboard: lvDashboard,
    products: lvProducts,
    orders: lvOrders,
    supplyorders: lvSupplyOrders,
    neworder: lvNeworder,
    admin: lvAdmin,
    pricing: lvPricing,
    documents: lvDocuments,
    traceability: lvTraceability,
    claims: lvClaims,
    tasks: lvTasks,
    registry: lvRegistry,
    security: lvSecurity,
    compliance: lvCompliance,
    insurance: lvInsurance,
    archive: lvArchive,
    chat: lvChat,
    auth: lvAuth,
    statuses: lvStatuses,
    offers: lvOffers,
    sodetail: lvSodetail,
  },
  lt: {
    common: ltCommon,
    dashboard: ltDashboard,
    products: ltProducts,
    orders: ltOrders,
    supplyorders: ltSupplyOrders,
    neworder: ltNeworder,
    admin: ltAdmin,
    pricing: ltPricing,
    documents: ltDocuments,
    traceability: ltTraceability,
    claims: ltClaims,
    tasks: ltTasks,
    registry: ltRegistry,
    security: ltSecurity,
    compliance: ltCompliance,
    insurance: ltInsurance,
    archive: ltArchive,
    chat: ltChat,
    auth: ltAuth,
    statuses: ltStatuses,
    offers: ltOffers,
    sodetail: ltSodetail,
  },
} as const satisfies Record<Locale, Record<string, unknown>>;

export { LOCALES, type Locale };
